import fetch from "@/utils/fetch";

// 用户管理 - 机构树形
export function getGmpTree(params) {
  return fetch({
    //  url: 'Rule/Rule/getOrganizationAndPostTree',
    url: "eavar/organization/tree",
    method: "post",
    data: params,
  });
}

// 用户信息列表
export function getUserList(params) {
  return fetch({
    //  url: 'User/User/getUserListByOrganizationId',
    url: "eavar/organization/users",
    method: "post",
    data: params,
  });
}

// zym.设置启用禁用
export function setDeleted(params) {
  return fetch({
    //  url: 'User/User/getUserListByOrganizationId',
    url: "eavar/organization/setDeleted",
    method: "post",
    data: params,
  });
}

// zym.获得所有的角色
export function getRoles(params) {
  return fetch({
    //  url: 'Rule/Rule/getOrganizationAndPostList',
    url: "manage/post/getOrganizationAndPostList",
    method: "post",
    data: params,
  });
}

// zym.根据角色获得可以操作的权限
export function getConfiged(params) {
  return fetch({
    url: "Rule/Rule/getUserPostRuleTree",
    method: "post",
    data: params,
  });
}

// zym.保存分配的角色
export function userConnectRole(params) {
  //  账号角色绑定
  return fetch({
    //  url: 'User/User/updateOrganizationUser',
    url: "manage/post/updateOrganizationUser",
    method: "post",
    data: params,
  });
}
// zym.用户新建、修改
export function userCreate(params) {
  //  账号新建

  return fetch({
    //  url: 'User/User/registerOrganization',
    url: "eavar/organization/addOrUpdateUser",
    method: "post",
    data: params,
  });
}

// zym.帐号删除
export function userRemove(params) {
  //  账号删除
  return fetch({
    //  url: 'User/User/delOrganizationUser',
    url: "eavar/organization/delOrganizationUser",
    method: "post",
    data: params,
  });
}

// zym.获取用户角色信息
export function getUserRoles(params) {
  return fetch({
    //  url: 'User/User/getOrganizationUserByUserId',
    url: "manage/post/getUserRolesByUserId",
    method: "post",
    data: params,
  });
}

/*新增管理员对用户的操作历史记录（分页）*/

export function UserAdminOperationList(params) {
  return fetch({
    url: "User/User/getUserAdminOperationList",
    method: "post",
    data: params,
  });
}

// zym.批量生成初始化数据 - 音像、电子
export function initPublisherStartBatch(params) {
  return fetch({
    url: "eavar/publisher/initPublisherStartBatch",
    method: "post",
    data: params,
  });
}

// zym.补充连续型出版物整改报告
export function fillReportForLxdz(params) {
  return fetch({
    url: "eavar/publisher/fillReportForLxdz",
    method: "post",
    data: params,
  });
}

export function recheckWorkerSum(params) {
  return fetch({
    url: "eavar/publisher/recheckWorkerSum",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/pgMent/userMent.js